import React from "react";
import PropTypes from "prop-types";
import { AppUtils } from "@src/utils";
import { useAuthContext } from "@src/context";
import AdminHooks from "@src/context/hooks/adminHooks";
import {
  BackButton,
  Button,
  CustomerDropDown,
  DropDown,
  FormInput,
  Loader,
  Tabs,
  TabSelector,
  Tag,
} from "@src/components/atoms";
import ErrorPage from "@src/components/layout/ErrorPage";
import { CardContainer } from "@src/components/cards";
import { adminEndpoints } from "@src/services/endpoints";
import { MessageBanner } from "@src/components/atoms";
import { SIGNOL_STAGE } from "@src/constants/constants";
import ReportsServiceSnsForm from "./ReportsServiceSnsForm";
import GoalPeriodTimelineTable from "./GoalPeriodTimelineTable";
import DonationsToolTable from "./DonationsToolTable";

const envTypeSimplified = SIGNOL_STAGE === "production" ? "PROD" : "DEV";

async function deployDynamicContent() {
  if (
    confirm(
      "This will deploy all dynamic content 'text replacements' to production." +
        "\nPlease ensure any features that need to go into production alongside this are also deployed." +
        "\nThis process will take 5-10 mins to appear in production (Please avoid retrying within this time)." +
        "\nAre you sure you want to continue?",
    )
  ) {
    return await adminEndpoints.deployDynamicContent("full");
  }
}
async function deployDCGridLayouts() {
  if (
    confirm(
      "This will deploy all current 'Manager Layouts' to production (via Dynamic Content)." +
        "\nPlease ensure there are no incomplete customer layouts." +
        "\nPlease ensure any behive process that need to go into production alongside this are also deployed." +
        "\nThis process will take a few seconds to appear in production." +
        "\nAre you sure you want to continue?",
    )
  ) {
    return await adminEndpoints.deployDynamicContent("layouts");
  }
}
async function clearBackendCaches() {
  if (
    !confirm(
      "This will empty all backend caches (Operator and Manager as of writing)" +
        "\nFor operator caches, the effect is probably not noticeable." +
        "\nFor manager caches, this can lead to a longer load time for the first page load, per customer." +
        "\nThe 'old' (pre-layouts) Manager pre-signol stats may also change (it is only recalculated if cache is cleared)." +
        "\nThis process will take a few seconds to complete." +
        "\nAre you sure you want to continue?",
    )
  ) {
    return await adminEndpoints.clearBackendCaches();
  }
}

const AdvancedTaskJobTriggerSection = () => {
  //const auth = useAuthContext();
  return (
    <section className="bg-yellow-100 p-8">
      <div className="flex flex-row gap-4 items-start">
        <fieldset className="border border-neutral-200">
          <legend className="ms-2 px-2">Dynamic Content</legend>
          <Button color="yellow" onClick={deployDynamicContent}>
            Deploy Dynamic Content to PROD
          </Button>
          <Button color="yellow" onClick={deployDCGridLayouts}>
            Deploy Grid Layouts to PROD
          </Button>
        </fieldset>

        <fieldset className="border border-neutral-200">
          <legend className="ms-2 px-2">Backend Caches</legend>
          <Button color="yellow" onClick={clearBackendCaches}>
            Clear all Caches ({envTypeSimplified})
          </Button>
        </fieldset>
      </div>
    </section>
  );
};

const AdvancedPage = () => {
  return (
    <section className="m-4">
      {envTypeSimplified === "PROD" && (
        <MessageBanner
          color="error"
          title="CAUTION"
          message="You are currently operating in the PRODUCTION environment."
          icon="warning"
        />
      )}
      <h1 className="text-center m-4">Advanced Admin</h1>
      <Tabs
        tabs={[
          {
            name: "Trigger Reports",
            colour: "pink",
            content: <ReportsServiceSnsForm />,
          },
          {
            name: "Internal Tasks/Jobs",
            colour: "yellow",
            content: <AdvancedTaskJobTriggerSection />,
          },
          {
            name: "Goal Period Timeline",
            colour: "lightblue",
            content: <GoalPeriodTimelineTable />,
          },
          {
            name: "Donations Tool",
            colour: "green",
            content: <DonationsToolTable />,
          },
        ]}
        gap
      />
    </section>
  );
};

export default AdvancedPage;
